const commentItems = [
  {
    id: 1,
    name: '漫画迷小白',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20portrait%20of%20a%20young%20girl%20with%20pink%20hair%2C%20simple%20background%2C%20warm%20lighting%2C%20clean%20illustration&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    text: '飞飞漫画网真的太良心了！下拉式阅读比翻页爽太多了，追《斗罗大陆》根本停不下来。而且真的完全免费，不用充会员也能看所有漫画，强烈推荐给所有喜欢看漫画的朋友！',
    time: '2小时前',
  },
  {
    id: 2,
    name: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20boy%20avatar%20with%20dark%20hair%20and%20glasses%2C%20minimal%20design%2C%20warm%20tone%2C%20clean%20illustration&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    text: '每天睡前必刷飞飞漫画！更新速度真的快，热门漫当天就能看到最新话。离线缓存功能也很实用，坐地铁的时候不用流量也能看，简直通勤神器。',
    time: '5小时前',
  },
  {
    id: 3,
    name: '国漫铁粉阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20with%20spiky%20hair%2C%20confident%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    text: '国漫这几年质量真的起飞了！飞飞漫画上的国漫分类特别全，《凡人修仙传》《完美世界》《遮天》全都有。支持国产漫画，希望越做越好！',
    time: '8小时前',
  },
  {
    id: 4,
    name: '韩漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20anime%20style%20female%20avatar%20with%20wavy%20brown%20hair%2C%20warm%20friendly%20expression%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-comment-04&orientation=squarish',
    text: '找了好久才找到韩漫这么全的站！《我独自升级》完结篇在这里一口气看完了，画质超清晰。希望后续能引进更多韩国热门漫画，飞飞加油！',
    time: '12小时前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">读者心声</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            来自飞飞漫画网真实读者的评价和反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-sm text-foreground-950">{item.name}</h3>
                  <span className="text-[11px] text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-1 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}